<template>
    <div
        class="md-video layout2 mg-bg"
        :style="{ ...spaceStyle, ...colorStyle, backgroundColor: bgColor }"
    >
        <div :fullColumn="fullColumn" class="md-video-inner f-col">
            <div class="title-wrap" v-if="title || desc">
                <site-title :title="title" :size="34" :mbSize="20" v-animated="{name: 'shift-right', enable: showAnimationEffects}" />
                <site-sub-title
                    class="desc"
                    :title="desc"
                    :size="16"
                    :mbSize="16"
                    v-animated="{name: isMobileSize ? 'shift-right' : 'shift-left', enable: showAnimationEffects}"
                />
            </div>
            <swiper
                class="video-list"
                :class="'len-' + useVideoList.length"
                v-bind="swiperOptions"
                v-if="useVideoList.length"
            >
                <slide
                    v-for="(videoOption, index) in useVideoList"
                    :key="videoOption.previewSrc + index"
                    class="video-item"
                >   
                    <bannerVideoContent :videoOption="videoOption">
                        <template #bannerVideo="{setRef}">
                            <banner-video
                                :ref="setRef"
                                :src="videoOption.src"
                                :previewSrc="videoOption.previewSrc"
                                isContain
                                :option="videoOption"
                            />
                        </template>
                        <template #bannerMask>
                            <div
                                v-if="
                                    maskOption &&
                                        maskOption.showMask &&
                                        videoOption.previewSrc
                                "
                                class="mask"
                                :style="{
                                    backgroundColor: maskOption.maskColor
                                }"
                            ></div>
                        </template>
                    </bannerVideoContent>
                </slide>
                <slide
                    v-if="useVideoList.length === 1 && !isMobileSize"
                    class="video-item placeholder-image"
                >
                    <site-img class="paly-btn-img" :src="imgSrc" />
                </slide>
            </swiper>
            <div v-else class="video-list video-empty">
                <div class="video-item placeholder-image">
                    <site-img class="paly-btn-img" :src="imgSrc" />
                </div>
                <div class="video-item placeholder-image" v-if="!isMobileSize">
                    <site-img class="paly-btn-img" :src="imgSrc" />
                </div>
            </div>
            <div class="btn-wrap" v-if="!isMobileSize">
                <div
                    class="swiper-button-wrap"
                    v-if="useVideoList?.length > 3 && !isMobileSize"
                >
                    <span class="swiper-button prevbutton">
                        <i class="iconfont icon-arrow_06_left"></i>
                    </span>
                    <span class="swiper-button nextbutton">
                        <i class="iconfont icon-arrow_06_right"></i>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import common from '../index';
import { Swiper, SwiperSlide, fixSwiperOptions } from '@/common/swiper';
export default {
    mixins: [common],
    components: {
        Swiper,
        Slide: SwiperSlide
    },
    data() {
        return {
            imgSrc: 'https://cdn.chime.me/image/fs/sitebuild/2024731/2/original_b4e1960b-c31b-4fa0-93c3-add72edcf863.png'
        };
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        useVideoList() {
            if (!this.videoList) {
                return [];
            }
            let { autoplay, showProgress, showMuteButton, autoHeight } = this.videoOption;
            return this.videoList.map(video => {
                return Object.assign(
                    {
                        autoplay: autoplay,
                        showProgress: showProgress,
                        showMuteButton: showMuteButton,
                        autoHeight: autoHeight,
                        playInline: true,
                        videoMuted: false,
                        hidePlayButton: false
                    },
                    video
                );
            });
        },
        swiperOptions() {
            let defaultOptions = {
                slidesPerView: this.isMobileSize ? 1.03 : 3,
                spaceBetween: this.isMobileSize ? 5 : 20,
                loop: false,
                navigation: {
                    closest: '.md-video',
                    prevEl: '.prevbutton',
                    nextEl: '.nextbutton',
                    disabledClass: 'swiper-button-disabled'
                },
                direction: 'horizontal',
                autoplay: false,
                speed: 1000,
                initialSlide: 0
            };
            return fixSwiperOptions(defaultOptions);
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';

.md-video.layout2 {
    .md-video-inner {
        // width: 1340px;
        // margin: 0 auto;
        overflow: hidden;
    }
    .title-wrap {
        margin-bottom: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .site-title {
            margin-right: 50px;
        }
    }
    .video-list {
        height: 320px;
        .video-item {
            height: 100%;
            .video-content {
                width: 100%;
                height: 100%;
                .mask {
                    position: absolute;
                    left: 0;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 1;
                    pointer-events: none;
                }
                .banner-video.is-play ~ .mask {
                    display: none;
                }
            }
            .banner-video {
                .preview {
                    background-color: rgba(218, 218, 218, 0.3);
                }
                .video-box.def video {
                    object-fit: cover;
                }
                .play-video {
                    width: 64px;
                    height: 64px;
                    border-width: 1px;
                    &:after {
                        left: 27px;
                        border-top: 8px solid transparent;
                        border-bottom: 8px solid transparent;
                        border-left: 14px solid white;
                    }
                    &:hover {
                        background: rgba(25, 25, 25, 0.1);
                    }

                    @include media-800 {
                        width: 40px;
                        height: 40px;
                        &:after {
                            border-top: 5px solid transparent;
                            border-bottom: 5px solid transparent;
                            border-left: 10px solid white;
                            left: 15px;
                        }
                    }
                }
            }
        }
        .placeholder-image {
            background-color: rgba(218, 218, 218, 0.3);
            display: flex;
            align-items: center;
            justify-content: center;
            .paly-btn-img {
                width: 100px;
                height: 87.5px;
                background-size: 100%;
                background-repeat: no-repeat;
                opacity: 0.3;
                @include media-800 {
                    width: 50px;
                    height: 44px;
                }
            }
        }
        &.len-1,
        &.len-2 {
            .video-item {
                width: calc((100% - 20px) / 2) !important;
            }
        }
    }
    .video-empty {
        display: flex;
        gap: 20px;
        .video-item {
            flex: 1;
            @include media-800 {
                flex: none;
                margin-right: 0 !important;
                width: calc(100% - 15px) !important;
            }  
            .video-content {
                width: 100%;
                height: 100%;
            }          
        }
    }
    .btn-wrap {
        margin-top: 40px;
        display: flex;
        justify-content: center;
        .swiper-button-wrap {
            width: 130px;
            height: 50px;
            display: flex;
            justify-content: space-between;
            .swiper-button {
                display: block;
                width: 50px;
                height: 100%;
                line-height: 50px;
                text-align: center;
                cursor: pointer;
                border-radius: 50%;
                color: var(--g-btn-background);
                border: 1px solid var(--g-btn-background);
                position: relative;

                &:hover::after {
                    content: '';
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    background-color: rgba(25, 25, 25, 0.1);
                }

                &.swiper-button-disabled,
                &.swiper-button-lock {
                    cursor: not-allowed;
                    opacity: 0.3;
                    &:hover {
                        cursor: not-allowed;
                    }
                }
                .iconfont {
                    font-size: 20px;
                }
            }
        }
    }
    @include media-800 {
        .f-col.md-video-inner {
            width: 100%;
        }
        .title-wrap {
            padding: 0 15px;
            margin-bottom: 20px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            .site-title {
                margin-right: 0;
                margin-bottom: 20px;
            }
        }
        .video-list {
            width: 100%;
            height: 255px;
            padding-left: 15px;
            .video-item {
                width: 345px;
                height: 100%;
                margin-right: 5px;
            }
            &.len-1,
            &.len-2 {
                .video-item {
                    width: calc(100% - 15px) !important;  
                }
            }
            &.len-1 {
                margin-right: 0 !important;
            }
        }

        .btn-wrap {
            margin-top: 20px;
            padding: 0 15px;
        }
    }
}
</style>
